// extracted by mini-css-extract-plugin
export default {"the3dPreview":"The3dPreview_the3dPreview__vBTI5"};